import firebase from 'firebase/app'
import 'firebase/firestore'

const SETTINGS_DOC_ID = 'RdU2ynqqASPB2KWFDphs'
const DOMAIN_ACCESS_DOC_ID = 'domainAccess'
const DEFAULT_LINE_LINK = 'https://lin.ee/tqR1wJD'
const GET_SALE_LINE_LINK_ENDPOINT = 'https://asia-east2-time2-lucky.cloudfunctions.net/getSaleLineLink'
const PUBLIC_API_KEY = 'LosnQ8W6uWoVs8N-ik_'
const axios = require('axios').default

const DEFAULT_SETTINGS = {
  lineAt: 'Time2lucky',
  linkLine: DEFAULT_LINE_LINK,
  adminContactLineLink: DEFAULT_LINE_LINK
}

const normalizeDomain = (value) => {
  const rawValue = (value || '').toString().trim().toLowerCase()
  if (!rawValue) return ''

  return rawValue
    .replace(/^https?:\/\//, '')
    .replace(/^\/\//, '')
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .replace(/:\d+$/, '')
}

const normalizeDomainAccess = (data) => {
  const seen = {}
  const domains = Array.isArray(data && data.domains) ? data.domains : []

  return {
    domains: domains.reduce((result, domain) => {
      const host = normalizeDomain(domain && domain.host)
      if (!host || seen[host]) return result
      seen[host] = true
      result.push({
        host,
        active: domain && domain.active === true
      })
      return result
    }, []),
    partnerReferralHost: normalizeDomain(data && data.partnerReferralHost)
  }
}

const normalizeSaleCode = (value) => {
  const rawValue = (value || '').toString().trim()
  if (!rawValue || rawValue === '0') return ''
  return rawValue.split('@')[0].trim().toLowerCase()
}

function normalizeSettings(settings = {}) {
  return {
    lineAt: settings.lineAt || DEFAULT_SETTINGS.lineAt,
    linkLine: settings.linkLine || DEFAULT_SETTINGS.linkLine,
    adminContactLineLink: settings.adminContactLineLink || settings.linkLine || DEFAULT_SETTINGS.adminContactLineLink
  }
}

export default {
  async fetchSettings({ commit, state }, options = {}) {
    // If settings already loaded, don't fetch again (save costs)
    const force = options && options.force === true
    if (state.isLoaded && !force) {
      return
    }

    try {
      const db = firebase.firestore()
      const [settingsDoc, domainAccessDoc] = await Promise.all([
        db.collection('settings').doc(SETTINGS_DOC_ID).get(),
        db.collection('settings').doc(DOMAIN_ACCESS_DOC_ID).get()
      ])

      const domainAccess = domainAccessDoc.exists
        ? normalizeDomainAccess(domainAccessDoc.data())
        : {}

      if (settingsDoc.exists) {
        commit('SET_SETTINGS', {
          ...normalizeSettings(settingsDoc.data()),
          ...domainAccess
        })
      } else {
        // If document doesn't exist, use default values
        commit('SET_SETTINGS', {
          ...DEFAULT_SETTINGS,
          ...domainAccess
        })
      }
    } catch (error) {
      console.error('Error fetching settings:', error)
      // On error, use default values
      commit('SET_SETTINGS', DEFAULT_SETTINGS)
    }
  },
  async resolveAdminContactLineLink({ commit, dispatch, state }, user = {}) {
    if (!state.isLoaded) {
      await dispatch('fetchSettings')
    }

    const fallbackLink = state.defaultAdminContactLineLink || state.linkLine || DEFAULT_LINE_LINK
    const salecode = normalizeSaleCode(user && user.userFriendId)

    if (!salecode) {
      commit('SET_ADMIN_CONTACT_LINE_LINK', fallbackLink)
      return fallbackLink
    }

    try {
      const response = await axios({
        method: 'post',
        url: GET_SALE_LINE_LINK_ENDPOINT,
        headers: {
          'x-api-key': PUBLIC_API_KEY,
          'Content-Type': 'application/json'
        },
        data: { salecode }
      })

      const employees = (response.data && response.data.employees) ? response.data.employees : []
      const employee = employees.length > 0 ? employees[0] : null
      const lineLink = (employee && employee.admin_contact_line) || fallbackLink

      commit('SET_ADMIN_CONTACT_LINE_LINK', lineLink)
      return lineLink
    } catch (error) {
      console.error('Error resolving admin contact line link:', error)
      commit('SET_ADMIN_CONTACT_LINE_LINK', fallbackLink)
      return fallbackLink
    }
  }
}
